<template>

  <div class="content">
    <div class="container-fluid">
      <card>
        <h4 class="mt-0">Tesis Ekle</h4>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center"><i class="fas fa-exclamation-triangle"></i> Hata</h4>
          <ul class="mb-0">
            <li v-for="e in errors">
              <b>{{e}}</b> Alanını Doldurmanız gerek
            </li>
          </ul>
        </b-alert>


        <div class="row">
          <div class="col-6 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Başlık</span>
            </div>
            <input type="text" class="form-control" placeholder="Başlık" aria-label="Başlık" v-model="post.name" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-6 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Kutu Linki</span>
            </div>
            <input type="text" class="form-control" placeholder="Link" aria-label="Başlık" v-model="post.link"  aria-describedby="basic-addon1">
          </div>
                   <div class="col-6 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Alt Başlık</span>
            </div>
            <input type="text" class="form-control" placeholder="Alt Başlık" aria-label="Alt Başlık" v-model="post.subtitle"  aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-11">
                            <div class="row">
                  <div class="col-12 col-md-6 m-3">
                                <small class="d-block w-100 mb-3">150 x 150 pixel</small>

                     <b-btn v-b-modal.croppieModal v-on:click="initiateCroppie('main')" v-bind:class="{'is-invalid' : errors.includes('image')}">Resim Seç</b-btn>
                    <img v-if="image.cropped" v-bind:src="image.cropped" class="img-fluid mt-4 d-block border border-secondary p-2" v-bind:class="{'border-danger' : errors.includes('Resim')}">
                  </div>
                </div>
          </div>


          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
        <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
          
          <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()">
          <vue-croppie :enable-resize="true" :viewport="{width: 150, height: 150, type: 'suare'}" :boundary="{width: 200, height: 200}" ref=main :enableOrientation="true" @result="result">
          </vue-croppie>
          <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
          <b-btn class="mt-3" variant="success btn-fill float-right" @click="crop()">Kaydet</b-btn>
        </b-modal>
      </card>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/UIComponents/Cards/Card.vue';
import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue';
export default {
  data: function () {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Activityprogrampage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    }
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    addImageToEditor: function (i) {
      this.$http
        .post('/api/images/upload/' + this.post.name + 'act_inner-image', {
          cropped: i
        })
        .then(
          response => {
            this.content.content =
              this.content.content +
              '<img src="' +
              this.mediaURL() +
              response.body.Data.Response.name +
              '" width="100%" alt="'+'" />'
          },
          e => {
            button.innerHTML = 'Kaydet';
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          }
        )
    },
    checkForm: function () {
      this.errors = []
      if (!this.post.name) {
        this.errors.push('Başlık')
      }
      if (!this.image.cropped) {
        this.errors.push('Resim')
      }
      if (!this.errors.length) {
        this.save()
      }
    },
    save: function () {
      this.toggleLoader()
      this.validateUrl()
      .then(resolve => {
           document.getElementById('url').classList.add('is-invalid')
           document.getElementById('url').classList.remove('is-valid')
           document.getElementById('url-label').classList.add('is-invalid')
           document.getElementById('url-label').classList.remove('is-valid')
          this.notifier(
            'top',
            'right',
            'danger',
            'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin'
          )
          this.toggleLoader()
        })
        .catch(er => {
          var button = event.target
          button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
          this.saveImage()
        })
    },
    saveImage: function () {
      this.$http.post('/api/images/upload/' +  this.slugify(this.post.name), this.image).then(
        response => {
          this.post.image = response.body.Data.Response.name
          this.savePost()
        },
        e => {
          button.innerHTML = 'Kaydet';
          this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          this.toggleLoader()
        }
      )
    },
    savePost: function () {
      var newdate = new Date();
      if(!this.post.url){
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140)
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(
          this.content.content,
          { allowedTags: ['br'] }
        ).substring(0, 500)
      }
      this.$http.post('/api/posts/add', this.post).then(
        response => {
          var pid = response.body.Data.Response.id
          this.post.id = pid
          this.metas.post_id = pid
          this.saveMetas()
        },
        e => {
          this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          this.toggleLoader()
        }
      )
    },
    saveMetas: function () {
      this.$http.post('/api/post-metas/add-bulk', this.metas).then(
        response => {
          this.notifier('top', 'right', 'success', 'Başarılı')
          this.$router.push('/activity-program-page')
          this.toggleLoader()
        },
        e => {
          this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          this.toggleLoader()
        }
      )
    },
    createUrl: function () {
      this.post.url = this.slugify(this.post.name)
    },
    slugifyUrl: function () {
      this.post.url = this.slugify(this.post.url)
    },
    validate: function () {
      this.validateUrl()
        .then(resolve => {
          document.getElementById('url').classList.add('is-invalid')
          document.getElementById('url').classList.remove('is-valid')
          document.getElementById('url-label').classList.add('is-invalid')
          document.getElementById('url-label').classList.remove('is-valid')
        })
        .catch(er => {
          document.getElementById('url').classList.add('is-valid')
          document.getElementById('url').classList.remove('is-invalid')
          document.getElementById('url-label').classList.add('is-valid')
          document.getElementById('url-label').classList.remove('is-invalid')
        })
    },
      validateUrl: function () {
      var request = this
      return new Promise(function (resolve, reject) {
        request.$http.get('/api/filter/posts/post-type/Activityprogrampage/name/' + request.post.name).then(
          response => {
            if (parseInt(response.body.meta.total) > 0) {
              resolve(true)
            } else {
              reject(false)
            }
          },
          response => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
            )
          }
        )
      })
    },
    initiateCroppie (type) {
      if (this.post.name) {
        this.croppieType = type
      } else {
        this.notifier(
          'top',
          'right',
          'danger',
          'Resim ekleyebilmek için bir başlık belirlemelisiniz.'
        )
      }
    },
    bind () {
      var oFReader = new FileReader()
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0])
        var refz = this.$refs
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          })
        };
      }
    },
    crop () {
      var dis = this
      var wdt = 150
      var hgt = 150
      if (this.croppieType === 'tinymce') {
        wdt = 150
        hgt = 150
      }
      return new Promise(resolve => {
        let options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1,
          backgroundColor:'#fff'
        }
        dis.$refs.main.result(options, output => {
          if (this.croppieType === 'main') {
            dis.image.cropped = output
          } else if (this.croppieType === 'tinymce') {
            this.notifier(
              'top',
              'right',
              'warning',
              'Lütfen resim yükleninceye kadar bekleyin.'
            )
            this.addImageToEditor(output)
          }
          this.hideCroppieModal()
          dis.$refs.main.refresh()
          resolve(output)
        })
      })
    },
    hideCroppieModal () {
      this.$root.$emit('bv::hide::modal', 'croppieModal')
    },
    result (output) {
      return output
    }
  }
}
</script>
<style>
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/ActivityProgramPage/Add.vue